import { memo } from 'react'
import Link from './Link'
const NavItem = memo(props => {
	return <Link {...props} />
})
export default NavItem
